<div class="update-document-card">
  <div *ngIf="updatedDocument.id" ubi-curve-header xlarge class="update-document-card__header">
    <div class="update-document-card__header-text">
      {{ 'edit_document.header' | translate }}
    </div>
  </div>
  <div *ngIf="!updatedDocument.id" ubi-curve-header xlarge class="update-document-card__header">
    <div class="update-document-card__header-text">
      {{ 'add_document.header' | translate }}
    </div>
  </div>
  <artemis-popover>
    <ng-container *ngFor="let section of ('add_document.info.content' | translate)">
      <ng-container *ngFor="let content of section.paragraph">
        <p>{{content}}</p>
      </ng-container>
    </ng-container>
  </artemis-popover>
  <div class="update-document-card__content-container">
    <artemis-loading-spinner *ngIf="uploading"></artemis-loading-spinner>
    <form class="update-document-card__form" [formGroup]="documentInfoForm" autocomplete="off">
      <div class="document-uploader">
        <label class="document-uploader__file-container btn btn_rounded"
          *ngIf="displayDocument && !displayDocument.thumbnail" for="documentUploader" matRipple>
          <input class="document-uploader__file-container-input" type="file" accept=".pdf,image/*" name="file"
            id="documentUploader" (change)="frontDocumentUploadedHandler($event.target.files)" />
          <img class="document-uploader__file-container-icon" src="/assets/icons/plus-icon-white.png">
          {{ 'add_document.button.upload_document' | translate }}
        </label>
        <div class="document-uploader__thumbnail-container" *ngIf="displayDocument && displayDocument.thumbnail"
          [class.document-uploader__thumbnail-container_empty]="!displayDocument.thumbnail && !updatedDocument.document">
          <ng-container *ngIf="displayDocument && displayDocument.thumbnail">
            <ng-container *ngIf="displayDocument.isFrontPdfFile; else showImage">
              <embed [src]="getThumbnail()" type="application/pdf"
                style="position: absolute; width: 100%; height: 100%">
            </ng-container>
            <ng-template #showImage>
              <div class="document-uploader__thumbnail-img-cover">
                <img [src]="getThumbnail()" />
              </div>
            </ng-template>
          </ng-container>
        </div>
        <div class="document-uploader__file-picker" *ngIf="displayDocument && displayDocument.thumbnail">
          <mat-form-field class="custom-mat-form-field document-uploader__file-picker-full" floatLabel="never"
            [ngClass]="{'custom-mat-form-field_mandatory': fcOrOcrEnabled}">
            <input matInput placeholder="{{ 'add_document.form.label.file' | translate }}" formControlName="docName"
              autocomplete="off">
          </mat-form-field>
          <input class="document-uploader__file-picker-input" type="file" accept=".pdf,image/*" name="file"
            id="documentUploader" (change)="frontDocumentUploadedHandler($event.target.files)" />
          <label class="document-uploader__file-picker-label btn btn_rounded" for="documentUploader" matRipple>
            {{ 'add_document.button.change_file' | translate }}
          </label>
        </div>
        <div class="document-uploader__thumbnail-container" *ngIf="displayDocument && displayDocument.backThumbnail"
          [class.document-uploader__thumbnail-container_empty]="!displayDocument.backThumbnail && !updatedDocument.backDocument">
          <ng-container *ngIf="displayDocument && displayDocument.backThumbnail">
            <ng-container *ngIf="displayDocument.isBackPdfFile; else showImage">
              <embed [src]="getBackThumbnail()" type="application/pdf"
                style="position: absolute; width: 100%; height: 100%">
            </ng-container>
            <ng-template #showImage>
              <div class="document-uploader__thumbnail-img-cover">
                <img [src]="getBackThumbnail()" />
              </div>
            </ng-template>
          </ng-container>
        </div>
        <div class="document-uploader__file-picker" *ngIf="displayDocument && displayDocument.backThumbnail">
          <mat-form-field class="custom-mat-form-field document-uploader__file-picker-name" floatLabel="never"
            [ngClass]="{'custom-mat-form-field_mandatory': fcOrOcrEnabled}">
            <input matInput placeholder="{{ 'add_document.form.label.file' | translate }}" formControlName="backDocName"
              autocomplete="off">
          </mat-form-field>
          <input class="document-uploader__file-picker-input" type="file" accept=".pdf,image/*" name="file"
            id="backDocumentUploader" (change)="backDocumentUploadedHandler($event.target.files)" />
          <label class="document-uploader__file-picker-label btn btn_rounded" for="backDocumentUploader" matRipple>
            {{ 'add_document.button.change_file' | translate }}
          </label>
          <label class="document-uploader__file-picker-label btn btn_rounded" (click)="removeBackDocument()">
            {{ 'add_document.button.remove_file' | translate }}
          </label>
        </div>
        <label class="document-uploader__file-container btn btn_rounded"
          *ngIf="displayDocument && !displayDocument.backThumbnail && displayDocument.thumbnail"
          for="backDocumentUploader" matRipple>
          <input class="document-uploader__file-container-input" type="file" accept=".pdf,image/*" name="file"
            id="backDocumentUploader" (change)="backDocumentUploadedHandler($event.target.files)" />
          <img class="document-uploader__file-container-icon" src="/assets/icons/plus-icon-white.png">
          {{ 'add_document.button.upload_other_side_of_document' | translate }}
        </label>
      </div>
      <div class="document-info">
        <!-- Document settings section -->
        <div class="document-info__section-label">
          {{ 'add_document.form.label.document_settings' | translate }}
        </div>
        <div class="document-info__doc-type-container">
          <mat-form-field
            class="custom-mat-form-field custom-mat-form-field_mandatory custom-mat-form-field_nested-select document-info__doc-type"
            [matMenuTriggerFor]="documentTypesMenu">
            <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
            <input matInput formControlName="docType"
              placeholder="{{ 'add_document.form.label.document_type' | translate }}">
          </mat-form-field>
          <mat-menu #documentTypesMenu="matMenu" class="custom-mat-menu-panel custom-mat-menu-panel_nested-select">
            <ng-container *ngFor="let documentTypeGroup of documentTypes">
              <ng-container *ngIf="documentTypeGroup.documentTypes.length">
                <button mat-menu-item [matMenuTriggerFor]="menu">{{documentTypeGroup.category}}</button>
                <mat-menu #menu="matMenu" class="custom-mat-menu-panel custom-mat-menu-panel_nested-select">
                  <button mat-menu-item *ngFor="let documentType of documentTypeGroup.documentTypes"
                    (click)="setSelectedDocumentType(documentTypeGroup.category, documentType)">{{documentType}}</button>
                </mat-menu>
              </ng-container>
              <ng-container *ngIf="!documentTypeGroup.documentTypes.length">
                <button mat-menu-item
                  (click)="setSelectedDocumentType(documentTypeGroup.category, documentTypeGroup.category)">{{documentTypeGroup.category}}</button>
              </ng-container>
            </ng-container>
          </mat-menu>
          <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory document-info__doc-type"
            appearance="fill" *ngIf="isOtherDocType">
            <mat-label>{{ 'add_document.form.label.other_document_type' | translate }} </mat-label>
            <textarea matInput rows="6" formControlName="otherDocType"></textarea>
          </mat-form-field>
        </div>
        <mat-form-field class="custom-mat-form-field document-info__select-form-field">
          <input matInput placeholder="{{ 'add_document.form.label.document_number' | translate }}"
            formControlName="documentNumber">
        </mat-form-field>
        <mat-form-field class="custom-mat-form-field document-info__select-form-field">
          <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
          <mat-select placeholder="{{ 'add_document.form.label.authenticity' | translate }}"
            formControlName="authenticity">
            <mat-option *ngFor="let authenticity of authenticities" [value]="authenticity">{{authenticity}}</mat-option>
          </mat-select>
        </mat-form-field>
        <!-- End document settings section -->
        <!-- Document date section -->
        <div class="document-info__section-label">
          {{ 'add_document.form.label.document_date' | translate }}
        </div>
        <mat-form-field class="custom-mat-form-field custom-mat-form-field_datepicker document-info__select-form-field">
          <input matInput [matDatepicker]="issueDatePicker"
            placeholder="{{ 'add_document.form.label.issue_date' | translate }}" formControlName="issueDate"
            autocomplete="off" (focus)="issueDatePicker.open()" [max]="maxIssueDate">
          <mat-datepicker-toggle matSuffix [for]="issueDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #issueDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="custom-mat-form-field custom-mat-form-field_datepicker document-info__select-form-field">
          <input matInput [matDatepicker]="expiryDatePicker"
            placeholder="{{ 'add_document.form.label.expiry_date' | translate }}" formControlName="expiryDate"
            autocomplete="off" (focus)="expiryDatePicker.open()" [min]="minExpiryDate">
          <mat-datepicker-toggle matSuffix [for]="expiryDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #expiryDatePicker></mat-datepicker>
        </mat-form-field>
        <!-- End document date section -->
        <mat-checkbox class="custom-mat-checkbox document-info__show-notifications-checkbox"
          formControlName="showExpiryAlerts">
          {{ 'add_document.form.label.show_expity_notifications' | translate }}
        </mat-checkbox>
      </div>
      <div class="save-button-container">
        <button class="btn btn_accent-gradient-rounded" type="submit" mat-button ubi-round-button
          (click)="updateDocument()" [disabled]="documentInfoForm.dirty && documentInfoForm.valid ? null: ''">
          {{ 'add_document.button.save' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>